import React from "react";

interface KonamiToastProps {
  visible: boolean;
  onDismiss: () => void;
}

export default function KonamiToast({ visible, onDismiss }: KonamiToastProps) {
  if (!visible) return null;

  return (
    <div className="fixed top-24 right-6 z-50 transition duration-200">
      <div className="bg-surface/95 border border-accent rounded-card shadow-glow px-5 py-4 min-w-[220px]">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-accent">Konami unlocked</p>
            <p className="text-sm text-text-muted mt-2">
              Secret channel accessed. Redirecting to the hidden artifact...
            </p>
          </div>
          <button
            aria-label="Dismiss konami notification"
            onClick={onDismiss}
            className="text-text-subtle hover:text-primary transition"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}

